import { updateSelfUser } from './UserRepository';
import { FieldValue } from '../utils/firebase';

export const addFavorie = (...productIDs) =>
  updateSelfUser({ favs: FieldValue.arrayUnion(...productIDs) });
export const remFavorie = (...productIDs) =>
  updateSelfUser({ favs: FieldValue.arrayRemove(...productIDs) });
